/**
 * Created by Simon Zhao on 01/27/2022.
 * Argument models of conditional diagram dialog.
 * ------ maintenance history ------
 */

export class DiagramConditionalDialogOptions {
    condition: string;
    fields: Array<any>;
}

export class DiagramConditionalDialogResult {
    isConfirmed = false;
    conditionResult: string;
}

